var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUserSolid1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 32,
    viewBox: "0 0 28 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_148_14859)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.9716 15.9674C16.089 15.9674 18.1197 15.1263 19.617 13.629C21.1142 12.1318 21.9554 10.1011 21.9554 7.98366C21.9554 5.86624 21.1142 3.83554 19.617 2.33829C18.1197 0.841045 16.089 -9.91821e-05 13.9716 -9.91821e-05C11.8542 -9.91821e-05 9.82346 0.841045 8.32621 2.33829C6.82897 3.83554 5.98782 5.86624 5.98782 7.98366C5.98782 10.1011 6.82897 12.1318 8.32621 13.629C9.82346 15.1263 11.8542 15.9674 13.9716 15.9674ZM11.1211 18.9613C4.97738 18.9613 0 23.9387 0 30.0825C0 31.1054 0.829563 31.935 1.85248 31.935H26.0907C27.1136 31.935 27.9432 31.1054 27.9432 30.0825C27.9432 23.9387 22.9658 18.9613 16.822 18.9613H11.1211Z",
    fill: "#CC7480"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_148_14859"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 27.9432,
    height: 31.9351,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserSolid1);
export default __webpack_public_path__ + "static/media/user-solid-1.e00557b798364724fa403419ab983659.svg";
export { ForwardRef as ReactComponent };